module.exports = __webpack_public_path__ + "img/lit_hex_rewards.ad50a6f8.png";